<ng-container *ngIf="mediaList">
    <app-image-slider-smart-tv (rowFocused)="rowFocused.emit()" [currentFocus]="currentFocus" [type]="'thumbs'" [items]="mediaList">
    </app-image-slider-smart-tv>
</ng-container>
<ng-container *ngIf="mediaList2">
    <app-image-slider-smart-tv (rowFocused)="rowFocused.emit()" [currentFocus]="currentFocus" [type]="'thumbs'" [items]="mediaList2">
    </app-image-slider-smart-tv>
</ng-container>
